import { create } from "zustand";

interface ReferralState {
  activeTabIndex: number;
  isDrawerOpen: boolean;

  setActiveTab: (index: number) => void;
  reset: () => void;
}

export const useReferralStore = create<ReferralState>((set) => ({
  activeTabIndex: 0,
  isDrawerOpen: false,

  setActiveTab: (index) => set({ activeTabIndex: index }),

  reset: () =>
    set({
      activeTabIndex: 0,
    }),
}));
